import {
  createAsyncThunk,
  createReducer,
  isFulfilled,
  isPending,
  isRejected,
} from "@reduxjs/toolkit";
import { RootState } from ".";
import { Questao, Resolucao, Usuario } from "../../sdk/@types";
import QuestaoService from "../../sdk/services/QuestaoService";
import ResolucaoService from "../../sdk/services/ResolucaoService";

interface ResolucaoState {
  list: Resolucao.ResolucaoQuestao[];
  filterQuery: Questao.QuestionFilterQuery;
  paginatedResult: Questao.PaginatedResult;
  questaoAnterior: Resolucao.ResolucaoQuestao;
  questaoAtual: Resolucao.ResolucaoQuestao;
  questaoProxima: Resolucao.ResolucaoQuestao;
  fetching: boolean;
}

const initialState: ResolucaoState = {
  list: [],
 

  filterQuery: {
  page: 1,
  limit: 10,
  answerStatus: "unanswered",
  keywords: [],
  keySubjectAgency: [],
},

  paginatedResult: {
    content: [],
    paginaAtual: 1,
    totalPaginas: 0,
    totalItens: 0,
  },
  questaoAnterior: {},
  questaoAtual: {},
  questaoProxima: {},
  fetching: false,
};

export const buscaPaginada = createAsyncThunk(
  "resolucao/buscaPaginada",
  async (_, { getState, dispatch }) => {
    const {
      resolucao: { filterQuery },
    } = getState() as RootState;

    const resultado = await QuestaoService.getQuestoesPaginadas(filterQuery);

    let novaLista: Questao.PaginatedResult;

    if (
      resultado &&
      resultado?.content?.length &&
      resultado?.content?.length > 0
    ) {
      novaLista = resultado;

      await dispatch(marcarResolucaoAnterior({}));
      if (novaLista.content && novaLista.content.length > 0) {
        await dispatch(marcarResolucaoAtual(novaLista.content[0]));
        if (novaLista.content.length > 1) {
          await dispatch(marcarResolucaoProxima(novaLista.content[1]));
        }
      }
    }

    return novaLista!;
  }
);

export const paginacaoAnterior = createAsyncThunk(
  "resolucao/paginacaoAnterior",
  async (_, { getState, dispatch, rejectWithValue }) => {
    const {
      resolucao: { filterQuery, paginatedResult },
    } = getState() as RootState;

    if (
      !paginatedResult ||
      !paginatedResult.totalPaginas ||
      paginatedResult.totalPaginas === 0
    ) {
      return rejectWithValue("Sem páginas para navegar");
    }

    if (paginatedResult.paginaAtual === 1) {
      return rejectWithValue("Primeira página");
    }

    const novoPage = paginatedResult?.paginaAtual
      ? paginatedResult?.paginaAtual - 1
      : 1;

    const filter = { ...filterQuery, page: novoPage, limit: 10 };

    const resultado = await QuestaoService.getQuestoesPaginadas(filter);

    let novaLista: Questao.PaginatedResult;

    if (
      resultado &&
      resultado?.content?.length &&
      resultado?.content?.length > 0
    ) {
      novaLista = resultado;

      if (novaLista?.content && novaLista.content.length > 1) {
        await dispatch(
          marcarResolucaoAnterior(
            novaLista.content[novaLista.content.length - 2]
          )
        );
      }
      if (novaLista.content && novaLista.content.length > 0) {
        await dispatch(
          marcarResolucaoAtual(novaLista.content[novaLista.content.length - 1])
        );
        if (novaLista.content.length > 1) {
          await dispatch(marcarResolucaoProxima({}));
        }
      }
    }

    return novaLista!;
  }
);

export const proximaPaginacao = createAsyncThunk(
  "resolucao/proximaPaginacao",
  async (_, { getState, dispatch, rejectWithValue }) => {
    const {
      resolucao: { filterQuery, paginatedResult },
    } = getState() as RootState;

    if (
      !paginatedResult ||
      !paginatedResult.totalPaginas ||
      paginatedResult.totalPaginas === 0
    ) {
      return rejectWithValue("Sem páginas para navegar");
    }

    if (paginatedResult.paginaAtual === paginatedResult.totalPaginas) {
      return rejectWithValue("Última página");
    }

    const novoPage = paginatedResult?.paginaAtual
      ? paginatedResult?.paginaAtual + 1
      : 1;

    const filter = { ...filterQuery, page: novoPage, limit: 10 };

    const resultado = await QuestaoService.getQuestoesPaginadas(filter);

    let novaLista: Questao.PaginatedResult;

    if (
      resultado &&
      resultado?.content?.length &&
      resultado?.content?.length > 0
    ) {
      novaLista = resultado;

      await dispatch(marcarResolucaoAnterior({}));
      if (novaLista.content && novaLista.content.length > 0) {
        await dispatch(marcarResolucaoAtual(novaLista.content[0]));
        if (novaLista.content.length > 1) {
          await dispatch(marcarResolucaoProxima(novaLista.content[1]));
        }
      }
    }

    return novaLista!;
  }
);

export const buscarQuestoesAleatorias = createAsyncThunk(
  "resolucao/buscarQuestoesAleatorias",
  async (
    {
      queryString,
      usuario,
    }: {
      queryString: String;
      usuario: Usuario.Usuario;
    },
    { dispatch }
  ) => {
    const resultado =
      await QuestaoService.getQuestaoAleatoriaPendenteOuNaoResolvida(
        queryString,
        usuario
      );

    let novaLista: Array<Resolucao.ResolucaoQuestao>;

    if (resultado.length > 0) {
      /* novaLista = resultado.map((item:any) => ({
        question: item,
      }));*/

      novaLista = resultado;

      await dispatch(marcarResolucaoAnterior({}));
      await dispatch(marcarResolucaoAtual(novaLista[0]));

      if (resultado.length > 1)
        await dispatch(marcarResolucaoProxima(novaLista[1]));
    }

    return novaLista!;
  }
);

export const confirmarResposta = createAsyncThunk(
  "resolucao/confirmarResposta",
  async (resolucao: Resolucao.ResolucaoQuestao, { getState, dispatch }) => {
    const {
      resolucao: { list },
    } = getState() as RootState;

    const resolucaoComRespostaConfirmada =
      await ResolucaoService.confirmarResposta(resolucao);

    const modificada: Array<Resolucao.ResolucaoQuestao> = list.map(
      (item: any) => {
        if (item.question?.id === resolucaoComRespostaConfirmada.question?.id) {
          return resolucaoComRespostaConfirmada;
        } else {
          return item;
        }
      }
    );

    return modificada;
  }
);

export const setFilter = createAsyncThunk(
  "resolucao/setFilter",
  async (filter: any, _) => {
    return filter;
  }
);

export const exibirResposta = createAsyncThunk(
  "resolucao/exibirResposta",
  async (resolucao: Resolucao.ResolucaoQuestao, { getState, dispatch }) => {
    const {
      resolucao: { list },
    } = getState() as RootState;

    const resolucaoComRespostaVerificada =
      await ResolucaoService.exibirResposta(resolucao);

    const modificada: Array<Resolucao.ResolucaoQuestao> = list.map(
      (item: any) => {
        if (item.question?.id === resolucaoComRespostaVerificada.question?.id) {
          return resolucaoComRespostaVerificada;
        } else {
          return item;
        }
      }
    );

    return modificada;
  }
);

export const marcarAcaoNasResolucoes = createAsyncThunk(
  "resolucao/marcarAcaoNasResolucoes",
  async (resolucao: Resolucao.ResolucaoQuestao, { getState, dispatch }) => {
    const {
      resolucao: { list },
    } = getState() as RootState;

    const modificada: Array<Resolucao.ResolucaoQuestao> = list.map(
      (item: any) => {
        if (item.question?.id === resolucao.question?.id) {
          return resolucao;
        } else {
          return item;
        }
      }
    );

    return modificada;
  }
);

export const marcarResolucaoAnterior = createAsyncThunk(
  "resolucao/marcarResolucaoAnterior",
  async (resolucao: Resolucao.ResolucaoQuestao) => {
    return resolucao;
  }
);

export const marcarResolucaoProxima = createAsyncThunk(
  "resolucao/marcarResolucaoProxima",
  async (resolucao: Resolucao.ResolucaoQuestao) => {
    return resolucao;
  }
);

export const marcarResolucaoAtual = createAsyncThunk(
  "resolucao/marcarResolucaoAtual",
  async (resolucao: Resolucao.ResolucaoQuestao, { getState, dispatch }) => {
    await dispatch(marcarAcaoNasResolucoes(resolucao));

    const {
      resolucao: { list, paginatedResult },
    } = getState() as RootState;

    list.map((item: any, index: any) => {
      if (item.question?.id === resolucao.question?.id) {
        if (index + 1 === 1) {
          dispatch(marcarResolucaoAnterior({}));
        } else {
          dispatch(marcarResolucaoAnterior(list[index - 1]));
        }

        if (index + 1 === list.length) {
          dispatch(marcarResolucaoProxima({}));
        } else {
          dispatch(marcarResolucaoProxima(list[index + 1]));
        }
      }
    });

    return resolucao;
  }
);

export default createReducer(initialState, (builder) => {
  const success = isFulfilled(
    buscarQuestoesAleatorias,
    buscaPaginada,
    proximaPaginacao,
    exibirResposta,
  );
  const error = isRejected(
    buscarQuestoesAleatorias,
    buscaPaginada,
    proximaPaginacao,
    exibirResposta,
  );
  const loading = isPending(
    buscarQuestoesAleatorias,
    buscaPaginada,
    proximaPaginacao,
    exibirResposta,
  );

  builder
    .addCase(setFilter.fulfilled, (state, action) => {
      state.filterQuery = action.payload;
    })

    .addCase(buscarQuestoesAleatorias.fulfilled, (state, action) => {
      state.list = action.payload;
    })
    .addCase(buscaPaginada.fulfilled, (state, action) => {
      state.paginatedResult = action.payload;
      state.list = action.payload?.content || [];
    })
    .addCase(proximaPaginacao.fulfilled, (state, action) => {
      state.paginatedResult = action.payload
        ? action.payload
        : state.paginatedResult;
      state.list = action.payload?.content || [];
    })
    .addCase(proximaPaginacao.rejected, (state, action) => {
      console.warn(
        "Paginação interrompida:",
        action.payload || action.error.message
      );
    })
    .addCase(paginacaoAnterior.fulfilled, (state, action) => {
      state.paginatedResult = action.payload
        ? action.payload
        : state.paginatedResult;
      state.list = action.payload?.content || [];
    })
    .addCase(paginacaoAnterior.rejected, (state, action) => {
      console.warn(
        "Paginação interrompida:",
        action.payload || action.error.message
      );
    })
    .addCase(marcarAcaoNasResolucoes.fulfilled, (state, action) => {
      state.list = action.payload;
    })
    .addCase(confirmarResposta.fulfilled, (state, action) => {
      state.list = action.payload.map((item: any) => {
        if (item && item.question && item.correct !== undefined) {
          item.question.resolvedCount = (item.question.resolvedCount || 0) + 1;
          if (item.correct === true) {
            item.question.correctCount = (item.question.correctCount || 0) + 1;
          }
        }
        return item;
      });
    })
    .addCase(exibirResposta.fulfilled, (state, action) => {
      state.list = action.payload;
    })
    .addCase(marcarResolucaoAtual.fulfilled, (state, action) => {
      state.questaoAtual = action.payload;
    })
    .addCase(marcarResolucaoAnterior.fulfilled, (state, action) => {
      state.questaoAnterior = action.payload;
    })
    .addCase(marcarResolucaoProxima.fulfilled, (state, action) => {
      state.questaoProxima = action.payload;
    })
    .addMatcher(success, (state) => {
      state.fetching = false;
    })
    .addMatcher(error, (state) => {
      state.fetching = false;
    })
    .addMatcher(loading, (state) => {
      state.fetching = true;
    });
});
